import React from "react";
import {
  DOC_STATUS_FILTER_ALL,
  DOC_STATUS_FILTER_OPTIONS,
} from "../utils/docStatus";

const DataViewSearchControls = ({
  activeLabel,
  searchInput,
  onSearchInputChange,
  onSubmit,
  onClear,
  selectedStatus = DOC_STATUS_FILTER_ALL,
  onStatusChange,
  showDocStatusFilter = false,
  perPage,
  onPerPageChange,
  pageSizeOptions,
  disabled = false,
}) => {
  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-3">
      <div className="flex flex-col gap-3 xl:flex-row xl:items-center">
        <div className="relative flex-1">
          <input
            type="text"
            value={searchInput}
            onChange={(event) => onSearchInputChange(event.target.value)}
            placeholder={`Search inside ${activeLabel}`}
            className="min-h-[3.5rem] w-full rounded-2xl border border-slate-700/80 bg-slate-950/90 px-5 pr-12 text-sm text-slate-100 outline-none transition-all placeholder:text-slate-500 focus:border-sky-500/60 focus:ring-4 focus:ring-sky-500/10"
          />
          <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-slate-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m21 21-4.35-4.35m1.85-5.15a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
              />
            </svg>
          </div>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
          <div className="flex gap-2 sm:gap-3">
            <button
              type="submit"
              disabled={disabled}
              className="min-h-[3.5rem] rounded-2xl bg-white px-5 text-sm font-semibold text-slate-950 transition-all hover:-translate-y-0.5 hover:bg-slate-100 disabled:cursor-not-allowed disabled:bg-slate-700 disabled:text-slate-400 disabled:shadow-none disabled:hover:translate-y-0 disabled:hover:bg-slate-700"
            >
              Search
            </button>
            <button
              type="button"
              onClick={onClear}
              className="min-h-[3.5rem] rounded-2xl border border-slate-700/80 bg-slate-900/70 px-5 text-sm font-semibold text-slate-200 transition-all hover:border-slate-500 hover:bg-slate-800/80 hover:text-white"
            >
              Clear
            </button>
          </div>

          {showDocStatusFilter ? (
            <div className="flex items-center gap-3">
              <div className="relative">
                <select
                  value={selectedStatus}
                  onChange={(event) => onStatusChange?.(event.target.value)}
                  disabled={disabled}
                  className="min-h-[3.5rem] appearance-none rounded-2xl border border-slate-700/80 bg-slate-950 px-4 pr-10 text-sm text-slate-100 outline-none transition-all hover:bg-slate-900 focus:border-sky-500/60 focus:ring-2 focus:ring-sky-500/20 disabled:cursor-not-allowed disabled:opacity-40"
                  aria-label="Document status filter"
                >
                  {DOC_STATUS_FILTER_OPTIONS.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-slate-400">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>

      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-3">
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            Rows Per Page
          </span>
          <div className="relative">
            <select
              value={perPage}
              onChange={(event) => onPerPageChange(event.target.value)}
              disabled={disabled}
              className="min-h-[2.9rem] appearance-none rounded-xl border border-slate-700 bg-slate-950 px-4 pr-10 text-sm text-slate-100 outline-none transition-all hover:bg-slate-900 focus:border-sky-500/60 focus:ring-2 focus:ring-sky-500/20 disabled:cursor-not-allowed disabled:opacity-40"
            >
              {pageSizeOptions.map((pageSizeOption) => (
                <option key={pageSizeOption} value={pageSizeOption}>
                  {pageSizeOption}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-slate-400">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default DataViewSearchControls;
